import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from "react-router-dom";

import { PickList } from 'primereact/picklist';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import axios from "axios"
// import { Steps } from 'primereact/steps';
// import { read, utils } from "xlsx";
// import { Button } from 'primereact/button';
// import UploadComponent from './UploadComponent';
// import DataTableComponent from '../../components/DataTable';
// import StepsNavigation from '../../components/StepsNavigation';
// import { InputText } from 'primereact/inputtext';
// import AlertComponent from '../../components/Alert';
// import Reviewsubmit from './Reviewsubmit';


// Import Styles
// import '../../styles/pages/addcsv.scss';

//  Import the Sample Table component
// import SamplesTable from '../../components/DataSamplesTable';

// Import the Data Search component
// import DataSearch from '../../components/DataSearch';

// import { PrimeIcons } from 'primereact/api';

const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

function MergedSampleManagement() {
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState(false)

    const location = useLocation();
    const [name, setName] = useState(null);
    const [datasetId, setDatasetId] = useState(null);

    const [error, setError] = useState("")

    // const [selectedSamples, setSelectedSamples] = useState(null);
    // const [rowClick, setRowClick] = useState(true);

    const [callapi,setCallapi] = useState(false);

    const [datasets, setDatasets] = useState([]);
    const [data, setData] = useState([]);

    const [navToDataset, setNavToDataset] = useState(false);




    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };

    const show = (value) => {
        toast.current.show({ severity: 'success', summary: 'Adding Sample to Dataset. Redirecting to dataset page.', detail: `${value.id}: ${value.name}`});
    };

    // Set the dataset name and id
    // and the page title
    useEffect(() => {
        if (location.state){
            setName(location.state.name);
            setDatasetId(location.state.id);
        } else {
            setName('No Dataset Selected');
            setDatasetId(null);
        }

        document.title = `Data -> Merge Samples | Palmona Pathogenomics`

    }, [location.state]);

    // Call the Dataset API to merge the samples into the Target dataset
    useEffect(() => {
        if (callapi) {
            // console.log('targetDataset', targetDataset);

     
            // Loop through the selected samples
            target.forEach(element => {
                // console.log('element', element);
                show(element); // Show the sample being added to the dataset

                const formData = new FormData();
                formData.append('userId' , getDataUserId);
                formData.append('sampleId', element.id);

                const headers = {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${getDataUserToken}`,
                };

                axios.patch( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${targetDataset.id}`, 
                formData, 
                { headers,
                }).then((response) => {
                    
                    console.log('response', response);
                    setNavToDataset(true);
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    setCallapi(false);
                });
            });
        }
    }, [callapi]);

    // End click down arrow to merge samples

    // Dataset Dropdown
    // Collect list of all datasets user has access to
    useEffect(() => {
        const getData = async () => {
            try {
            const response = await axios.get(
                `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset?userId=${getDataUserId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${getDataUserToken}`,
                    }
                });
                setData(response.data);
                setError(null);

            } catch (err) {
            setError(err.message);
            setData(null);
            } finally {
            setLoading(false);
            }
        };
        getData();

    }, []);

    useEffect(() => {
        if (data) {
            data.forEach(element => {
                const item = {name: element.name, id: element.id};
                setDatasets(datasets => [...datasets, item])
            });
        }
    }, [data]);

    // End of Dataset Dropdown    



    // Query the selected Dataset
    const [selectedDataset, setSelectedDataset] = useState(null);
    const [selectedDatasetData, setSelectedDatasetData] = useState(null);

    const [targetDataset, setTargetDataset] = useState(null);



    useEffect(() => {
        if (selectedDataset) {
            // console.log('selectedDataset', selectedDataset);

            const getData = async () => {
                try {
                  const response = await axios.get(
                    `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${selectedDataset.id}?userId=${getDataUserId}`,
                    {
                      headers: {
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${getDataUserToken}`,
                      }
                    }
                  );
                  setSelectedDatasetData(response.data);
                  setError(null);
                } catch (err) {
                  setError(err.message);
                  setSelectedDatasetData(null);
                } finally {
                  setLoading(false);
                }
            };

            getData();
        }
    }, [selectedDataset]);

    // Set the available samples
    const [avaliablesamples, setAvaliableSamples] = useState([]);
    useEffect(() => {
        if (selectedDatasetData) {
            setAvaliableSamples([]);
            // If we have data, then we can loop through the samples
            const newAvailableSamples = [];
            selectedDatasetData.samples.forEach(element => {
                // console.log('element', element);
                newAvailableSamples.push({id: element.id, sample: element.name, date: element.createdAt.split('T')[0], file1: element.file1, file2: element.file2, longitude: element.longitude, latitude: element.latitude, origin: element.origin, transmissionRate: element.transmissionRate})

                // To do: Add the samples to the top table
                // setAvaliableSamples(avaliablesamples => [...avaliablesamples, {id: element.id, sample: element.name, date: element.createdAt.split('T')[0], file1: element.file1, file2: element.file2, longitude: element.longitude, latitude: element.latitude, origin: element.origin, transmissionRate: element.transmissionRate}]);
            });
            newAvailableSamples.sort((a, b) => a.sample.toLowerCase() > b.sample.toLowerCase() ? 1 : -1);
            setAvaliableSamples(newAvailableSamples);
        }
    }, [selectedDatasetData]);

    

    function handleClick() {
        if (target) {            
            setCallapi(true);

            // const path = "/workflows" ; 
            // const path = "/datasets/dataset_details" ;
            // navigate(path,{
            //     state:{
            //         id:targetDataset.id,
            //         name:targetDataset.name
            //     }
            // });
      }
    }

    useEffect(() => {
        if (navToDataset) {
            const path = "/datasets/dataset_details" ;
            // console.log('path', path);
            setTimeout(() => navigate(path,{
                state:{
                    id:targetDataset.id,
                    name:targetDataset.name
                }
            }), 2000); 
        }
    }, [navToDataset]);


    // PickList
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    useEffect(() => {
        setSource(avaliablesamples);
    }, [avaliablesamples]);

    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                {/* <img className="w-4rem shadow-2 flex-shrink-0 border-round" src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} /> */}
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.sample}</span>
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-bolt text-sm"></i>
                        <span>{item.collection}</span>
                    </div>
                </div>
                {/* <span className="font-bold text-900">${item.price}</span> */}
            </div>
        );
    };
    // End of PickList

    return (
        <main className='container mt-2'>

        <Toast ref={toast} />
        <ConfirmDialog group="templating" />

            <div className="row d-flex justify-content-between">
                <h2>Merge Samples</h2>
                <p className='text-sm-left'>Copy one or more samples from one Dataset to another Dataset.</p>
            </div>

            <div className='row'>
                <div className='mt-2 pt-2 mb-0 pb-0 col text-lg'>
                    <span>Select a Dataset <strong><i>from</i></strong> which you wish to import samples.</span>
                </div>

                <div className='mt-2 pt-2 mb-0 pb-0 col text-lg'>
                    <span>Select a Dataset <strong><i>to</i></strong> which you wish to import samples.</span>
                </div>
            </div>

            <div className='row mt-2'>
                <div className="col flex ">
                    <div className='mx-auto'>
                    <Dropdown value={selectedDataset} onChange={(e) => setSelectedDataset(e.value)} options={datasets} optionLabel="name" 
                        placeholder="Select a Dataset to take a Sample FROM" className="w-full md:w-28rem" />
                    </div>
                </div>

                <div className="col flex">
                    <div className='mx-auto'>
                        <Dropdown value={targetDataset} onChange={(e) => setTargetDataset(e.value)} options={datasets} optionLabel="name" 
                            placeholder="Select a Dataset to add a Sample TO" className="w-full md:w-28rem" />
                    </div>
                </div>
            </div>

            <div className="row card">
                <PickList dataKey="id" source={source} target={target} onChange={onChange} itemTemplate={itemTemplate} breakpoint="1280px"
                    sourceHeader="From" targetHeader="To" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}/>
            </div>

            <div className="row card">
                <Button className="pi pi-caret-right mr-2" label="Configure Dataset" severity="warning" onClick={handleClick} />
            </div>
        </main>
    );
}

export default MergedSampleManagement;